var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('router-view'),(!_vm.flag && _vm.isMobile == 1)?_c('div',{staticClass:"customer_service",on:{"click":function($event){return _vm.to_customer()}}},[_c('div',{staticClass:"customer_service_cont"},[_c('div',{staticClass:"icons_cont"},[_c('img',{attrs:{"src":_vm.customer_img,"alt":""}})])])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }